/**
 * @generated SignedSource<<b40ad46c1540668e6251bd09b62c44f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeedbackCardActionsArchiveMutation$variables = {
  id: string;
};
export type FeedbackCardActionsArchiveMutation$data = {
  readonly markAsComplete: {
    readonly feedbackAndRequestsEdge: {
      readonly node: {
        readonly id?: string;
        readonly isArchived?: boolean;
      };
    };
  } | null;
};
export type FeedbackCardActionsArchiveMutation = {
  response: FeedbackCardActionsArchiveMutation$data;
  variables: FeedbackCardActionsArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isArchived",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "FeedbackNode",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "FeedbackRequestNode",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackCardActionsArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkAsCompleted",
        "kind": "LinkedField",
        "name": "markAsComplete",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackCardActionsArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkAsCompleted",
        "kind": "LinkedField",
        "name": "markAsComplete",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3931e87eee8221490736d60aae472444",
    "id": null,
    "metadata": {},
    "name": "FeedbackCardActionsArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackCardActionsArchiveMutation(\n  $id: ID!\n) {\n  markAsComplete(id: $id) {\n    feedbackAndRequestsEdge {\n      node {\n        __typename\n        ... on FeedbackNode {\n          id\n          isArchived\n        }\n        ... on FeedbackRequestNode {\n          id\n          isArchived\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "329e1a4945c594dc5c1e3dbdfa10f319";

export default node;
